export default "__VITE_ASSET__Dex67Qik__ 224w, __VITE_ASSET__C_eLqv2K__ 448w";